import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatGetToken} from './NatGetToken'
import {NatPostTokenFirstLogin} from './NatPostTokenFirstLogin'
import {NatPostTokenPassword} from './NatPostTokenPassword';
import {NatPostTokenMailAddress} from './NatPostTokenMailAddress';
import {NatPostTokenSubResidentUser} from './NatPostTokenSubResidentUser';
import {ApiResponse} from '../../../../network/response/ApiResponse'
import {NatBaseResponseInterface} from '../../common/repository/NatBaseResponseInterface'
import {Nullable} from '../../../../app/TypeHelpers';

export interface RegisterTokenFirstLoginRequest {
    mailAddress: string,
    authenticationKey: string,
    policyAgreeType: string
    referrerId: string
    referenceId: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
}

export interface RegisterTokenPasswordRequest {
    mailAddress: string,
}

export interface RegisterTokenMailAddressRequest {
    mailAddress: string,
    mailAddressCategoryFlg: string
}

export interface RegisterTokenSubResidentUserRequest {
    mailAddress: string,
    mailAddressConfirm: string,
    freeSettingItem: Nullable<string>
}

export default class NatTokenRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // トークン取得
    async getToken(token: string): Promise<NatGetToken> {
        return await this.http.get(`/api/resident/token/${token}`);
    }

    // トークン登録（初回ログイン）
    async registerTokenFirstLogin(requestParam: RegisterTokenFirstLoginRequest): Promise<NatPostTokenFirstLogin> {
        return await this.http.post(`/api/resident/token/firstLogin`,
            {
                mailAddress: requestParam.mailAddress,
                authenticationKey: requestParam.authenticationKey,
                policyAgreeType: requestParam.policyAgreeType,
                referrerId: requestParam.referrerId,
                referenceId: requestParam.referenceId,
                familyName: requestParam.familyName,
                firstName: requestParam.firstName,
                familyNameKana: requestParam.familyNameKana,
                firstNameKana: requestParam.firstNameKana
            },
            ContentType.JSON,
        );
    }

    // トークン登録（パスワード再発行）
    async registerTokenPassword(requestParam: RegisterTokenPasswordRequest): Promise<NatPostTokenPassword> {
        return await this.http.post(`/api/resident/token/password`,
            {
                mailAddress: requestParam.mailAddress,
            },
            ContentType.JSON,
        );
    }

    // トークン登録（メールアドレス変更）
    async registerTokenMailAddress(requestParam: RegisterTokenMailAddressRequest): Promise<NatPostTokenMailAddress> {
        return await this.http.post(`/api/resident/mailAddressToken`,
            {
                mailAddress: requestParam.mailAddress,
                mailAddressCategoryFlg: requestParam.mailAddressCategoryFlg
            },
            ContentType.JSON,
        );
    }

    // トークン登録（サブユーザ追加）
    async registerTokenSubResidentUser(requestParam: RegisterTokenSubResidentUserRequest):
        Promise<NatPostTokenSubResidentUser> {
        return await this.http.post(`/api/resident/subUserToken`,
            {
                mailAddress: requestParam.mailAddress,
                mailAddressConfirm: requestParam.mailAddressConfirm,
                freeSettingItem: requestParam.freeSettingItem,
            },
            ContentType.JSON,
        );
    }

    // 口座振替処理用トークンを取得
    async getTokenAccountTransfer(): Promise<ApiResponse<string>> {
        return await this.http.get('/api/resident/accountTransferToken')
    }

    // トークン登録（初回ログイン）
    async registerTokenNoAuthenticationKey(
        condominiumCd: string,
        mailAddress: string,
        mailAddressConfirm: string
    ): Promise<NatBaseResponseInterface> {
        return await this.http.post(`/api/resident/token/noAuthenticationKeyFirstLogin`,
            {
                condominiumCd: condominiumCd,
                mailAddress: mailAddress,
                mailAddressConfirm: mailAddressConfirm
            },
            ContentType.JSON,
        );
    }

}

